import { Button } from "@/ui/button";
import { IconComponent } from "@/ui/icon";
import { WalletSettingsModal } from "@/ui/modals";
import EthereumWalletControls from "./ethereum-wallets-control";
import SolanaWalletControls from "./solana-wallets-control";
import { useState } from "react";
import CreateNewWallet from "./create-new-wallet-btn";
import ImportWallet from "./import-wallet-btn";
import {
  BotWalletSupportedChain,
  useWallet,
  WalletType,
} from "@/providers/wallet";
import ReferralInfo from "./referral-info";
import { useGetBotUserInfo } from "@api/bot/bot-get-user-info.ts";
import { useBotReferralInfo } from "@api/bot/bot-get-referral-info.ts";
import { useParams } from "react-router";

const AccountSettingsModal = ({
  onClose,
  onConfirm,
}: {
  onClose: () => void;
  onConfirm: () => void;
}) => {
  const [isEth, setEth] = useState<boolean>(false);
  const { appPubKey, userId } = useWallet();
  const { tokenId } = useParams();
  const { data } = useGetBotUserInfo({ appPubKey, userId });
  const { data: referralInfo } = useBotReferralInfo({
    appPubKey,
    userId,
    chainId: tokenId?.startsWith("0x")
      ? BotWalletSupportedChain.ETH
      : BotWalletSupportedChain.SOL,
  });

  return (
    <WalletSettingsModal onClose={onClose} onConfirm={onConfirm}>
      <div className="flex justify-center align-center gap-[0.3125rem] text-xs hidden">
        <Button
          className="w-[20rem] "
          onClick={() => setEth(true)}
          active={isEth}
        >
          <IconComponent name="ethereum" />
          &nbsp; Ethereum
        </Button>
        <Button
          className="w-[20rem]"
          onClick={() => setEth(false)}
          active={!isEth}
        >
          <IconComponent name="solanaLogo" />
          &nbsp; Solana
        </Button>
      </div>
      <div className="flex flex-col gap-[0.3125rem]">
        {isEth && <EthereumWalletControls />}
        {!isEth && <SolanaWalletControls />}
        <CreateNewWallet walletType={isEth ? WalletType.ETH : WalletType.SOL} />
        <ImportWallet walletType={isEth ? WalletType.ETH : WalletType.SOL} />
        <ReferralInfo
          telegramReferralLink={data?.arkaineTelegramBotRefLink ?? ""}
          platformReferralLink={`${window.location.origin}?ref=${userId}`}
          referralReward={
            referralInfo?.referralRewards?.refEarned?.toString() ?? ""
          }
          referredUsers={referralInfo?.referalsCount ?? 0}
          referralRewards={"0"}
        />
      </div>
    </WalletSettingsModal>
  );
};

export default AccountSettingsModal;
